










import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class CircleCheckMarkIcon extends Vue {
  @Prop({ type: String, default: '#179E7E' }) private color!: string;
}
